import { bigEmailRe } from './regular-expressions'

export const replaceWhiteSpacesBy_ = (str: string) => {
  return str.replaceAll(' ', '_')
}

export const getStringWithOutColomns = (str: string) => {
  if (!str) return ''
  return str.replaceAll(',', ';')
}

export const removeAccents = (str: string) => {
  str = replaceWhiteSpacesBy_(str)
  return str.normalize('NFD').replace(/\p{Diacritic}/gu, '')
}

export const getLastSubstring = (str: string, quantity: number) => {
  if (str.length <= quantity) return str
  return str.substr(str.length - quantity)
}

export const getFirstSubstring = (str: string, quantity: number) => {
  if (!str) return ''
  if (str.length <= quantity) return str
  return str.substring(0, quantity)
}

export const isEmailValid = (email: string): boolean => {
  if (!email) return false
  var emailParts = email.split('@')
  if(emailParts.length !== 2) return false
  var account = emailParts[0]
  var address = emailParts[1]
  if(account.length > 64) return false
  else if(address.length > 255) return false
  var domainParts = address.split('.')
  if (domainParts.some(function (part) {
    return part.length > 63
  })) return false
  if (!bigEmailRe.test(email)) return false
  return true
}

export const getSubstringSpaceReplaced = (value: string, quantity: number = 8): string => {
  if (!value) return ''
  const valueWithoutSpaces = value.replaceAll(' ', '')
  if (valueWithoutSpaces.length <= quantity) return valueWithoutSpaces
  return getFirstSubstring(valueWithoutSpaces, quantity)
}

export const isUUID = (str: string): boolean => {
  const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/
  return uuidRegex.test(str)
}

export const isNumber = (cadena: string): boolean  => !isNaN(Number(cadena))
